<template>
  <div class="componentWrapper" @click="listenOut">

    <div id="service" :class="'privacy grid grid__item_span-12 p0 m0 project-' + page.colorTheme">

      <div id="pageheader" class="grid__item_span-12 grid m0 p0">
          <h1 class="grid__item_span-12 grid m0 p0">Privacy Policy</h1>
          <p class="grid__item_span-12 grid m0 p0">Website Privacy Policy for Blacksheepdesign.</p>
      </div>

      <!-- Project Content Wrapper  -->
      <div id="projectContent" class="grid__item_span-12 grid m0 p0">
        <div class="grid__item_span-8 grid m0 p0" v-html="pageContent"></div>
      </div>

    </div>

  </div>

</template>

<script>

import menuTransitions from '../assets/js/menu.js'
import animateScrollTo from 'animated-scroll-to'
import Axios from 'axios'

export default {
  name: 'Service',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      logoColour: 'black',
      metaTitle: '',
      metaDescription: '',
      pageContent: '',
      page: {},
      siblings: [],
      nav: [],
      nextPageLink: '',
      projectType: ''
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { name: 'description', content: this.metaDescription }
      ]
    }
  },
  computed: {
    findLogoColour: function () {
      // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    }
  },
  methods: {
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/867').then(response => {
        console.log(response.data)
        this.metaTitle = response.data.acf.meta_title
        this.metaDescription = response.data.acf.meta_description
        this.pageContent = response.data.content.rendered
      }).catch(function (error) {
        console.log(error)
      })
    },
    scrollTo (destination) { // scroll to a div position
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    nextPage () {
      // this.navigationDirection = 'forward'
      // console.log(this.nav)
      // console.log(this.$route.params.slug)
      var navLength = this.nav.length - 1
      var currentSlug = this.$route.params.slug
      var nextPage = ''
      var currentPage = this.nav.indexOf(currentSlug)
      if (currentPage === navLength) {
        nextPage = this.nav[0]
      } else {
        nextPage = this.nav[currentPage + 1]
      }
      // console.log(nextPage)
      this.nextPageLink = nextPage
      // if (nextPage) { this.$router.push(nextPage) }
    }
  },
  mounted () {
    // Hide the bsdText div until we scroll
    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    setTimeout(function () {
      if (document.getElementById('contactClick')) {
        document.getElementById('contactClick').addEventListener('click', function () {
          setTimeout(function () {
            var destinationWrap = document.getElementById('footer-sec')
            const options = {
              speed: 1900
            }
            animateScrollTo(destinationWrap, options)
          }, 200)
        })
      }
    }, 500)
  },
  created () {
    this.getData()
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #pageheader{
    padding-top: 13vh;
    padding-left: 9.5vw;
    padding-bottom: 10vh;
  }

  #pageheader h1{
    color: white;
    font-family: 'billCorp_super';
    text-transform: initial;
    font-size: 1.8vw;
    line-height: 150%;
    letter-spacing: 0.13vw;
  }

  #pageheader p{
    font-size: 1.3vw;
    line-height: 2.1vw;
    color: white;
    margin-top: 3vh;
  }

  #projectContent{
    background: white;
    padding: 10vh 10vw 10vh;
  }

</style>



// WEBPACK FOOTER //
// src/components/policy.vue